import { render, staticRenderFns } from "./Spezial.vue?vue&type=template&id=678f1fcc&"
import script from "./Spezial.vue?vue&type=script&lang=js&"
export * from "./Spezial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports